import {checkRole} from '../components/Can/Can';

export const checkIsAdmin = (includeThirdParty: boolean = true) => {
    const wcvAdmin = checkRole(['super-admin', 'admin']);
    const thirdPartyAdmin = checkIsThirdPartyAdmin();
    if(includeThirdParty) return wcvAdmin || thirdPartyAdmin;
    return wcvAdmin;
};

export const checkIsThirdPartyAdmin = () => {
    return checkRole(['admin-3rd-party']);
};

export const checkIsSuperAdmin = () => {
    return checkRole(['super-admin']);
};
